<!-- title -->
<app-modal-title
  [title]="pageVocabs + 'legend' | translate"
  [isShowClose]="true"
  (isCloseModal)="onClose()"
></app-modal-title>

<div mat-dialog-content class="dialog-content" style="max-width: 600px">
  <ng-container *ngIf="!isSuccessPurchase">
    <div class="row">
      <!-- form -->
      <section class="md:tw-w-1/2 tw-pl-5">
        <form [formGroup]="form">
          <div class="tw-flex tw-justify-between tw-items-center flex-column">
            <div class="row tw-mt-[20px]">
              <!-- number -->
              <div class="tw-w-full">
                <p class="tw-text-gray-700 dark:tw-text-gray-300 tw-pr-1 tw-mb-2 tw-text-[12px]">
                  {{ messages + "privateNumberPriceNumber" | translate }}
                </p>

                <form-field
                  type="tel"
                  [isOnlyNumber]="true"
                  class="tw-w-full"
                  [label]="fields + 'privateNumberPriceNumber' | translate"
                  [control]="form?.get('number')"
                  [(value)]="model.number"
                  [maxLength]="privateNumberPrice.numberOfDigits"
                >
                  <span prefix-content>
                    <i class="text-blue mdi mdi-sim-outline mdi-24px"></i>
                  </span>
                </form-field>
              </div>

              <!-- discountCode -->
              <div class="tw-w-full">
                <app-verify-discount-input
                  class="tw-w-full"
                  [discountPlace]="DiscountPlace.PrivateNumberPurchase"
                  [id]="model.privateNumberPriceId"
                  (result)="getVerifyDiscountResult($event)"
                >
                </app-verify-discount-input>
              </div>
            </div>
          </div>
        </form>
      </section>

      <!--#region summary  -->
      <section class="md:tw-w-1/2 tw-mt-2 border-right-dashed">
        <div class="tw-p-4 rounded tw-w-full">
          <!--#region credit  -->
          <div class="tw-mt-2">
            <div
              class="tw-flex tw-justify-between tw-items-center border-bottom-dashed tw-pb-3 tw-mb-3"
            >
              <div class="tw-text-gray-700 dark:tw-text-gray-300 tw-text-[12px]">
                {{ "common.yourCredit" | translate }}
              </div>

              <div class="tw-flex-center tw-mr-2" [credit]="organizationCredit">
                <div class="tw-relative credit-number">
                  <div class="tw-font-medium tw-text-[15px] credit-number-text">
                    {{ organizationCredit | numberSeparator }}
                  </div>
                </div>
              </div>
            </div>

            <div
              class="tw-py-2 tw-pb-5 tw-font-medium tw-text-[12px] tw-flex-center flex-column"
              *ngIf="organizationCredit < finalAmount"
            >
              <span class="text-danger tw-text-[13px] tw-mt-2">
                {{ "messages.notEnoughCredit" | translate }}
              </span>
              <span
                class="btn btn-sm tw-mt-2"
                (click)="openIncreaseCredit()"
                [themeColor]="'btn'"
              >
                {{ "common.increaseCredit" | translate }}
              </span>
            </div>
          </div>
          <!--#endregion -->

          <!--#region private number price  -->
          <div class="tw-mt-2">
            <div
              class="tw-flex tw-justify-between tw-items-center border-bottom-dashed tw-pb-3 tw-mb-3"
            >
              <div class="tw-text-gray-700 dark:tw-text-gray-300 tw-text-[12px]">
                {{ fields + "numberPrice" | translate }}
              </div>

              <div class="tw-flex-center tw-mr-2">
                <div class="tw-relative">
                  <div class="tw-font-medium tw-text-[15px] tw-text-gray-800">
                    {{ privateNumberPrice?.price | numberSeparator }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--#endregion -->

          <!--#region discount value  -->
          <div class="tw-mt-2">
            <div
              class="tw-flex tw-justify-between tw-items-center border-bottom-dashed tw-pb-3 tw-mb-3"
            >
              <div class="tw-text-gray-700 dark:tw-text-gray-300 tw-text-[12px]">
                {{ "common.discount" | translate }}
              </div>

              <div class="tw-flex-center tw-mr-2">
                <div class="tw-relative">
                  <div
                    class="tw-font-medium tw-text-[15px]"
                    [class]="
                      discountAmount ? 'text-success' : 'tw-text-gray-800'
                    "
                  >
                    {{ discountAmount | numberSeparator }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--#endregion -->

          <!--#region payment Amount  -->
          <div class="tw-flex tw-justify-between tw-items-center tw-mt-2">
            <div class="tw-text-gray-700 dark:tw-text-gray-300 tw-text-[12px]">
              {{ "common.payable" | translate }}
            </div>

            <div class="tw-flex-center tw-mr-2">
              <div class="tw-relative">
                <div class="tw-font-semibold tw-text-[25px] text-navyBlue">
                  {{ finalAmount | numberSeparator }}
                </div>
              </div>
              <small
                class="tw-text-[14px] tw-font-semibold tw-mr-[5px] ltr:tw-ml-[5px] text-navyBlue tw-mt-2"
                >{{ "common.currency" | translate }}</small
              >
            </div>
          </div>
          <!--#endregion -->
        </div>
      </section>
      <!--#endregion -->

      <!--#region tips  -->
      <section class="tw-w-full">
        <app-accordion-section
          [title]="'common.privateNumberPurchaseRules' | translate"
        >
          <div class="tw-mb-2">
            <span class="text-danger">*</span>
            <span class="tw-text-gray-700 dark:tw-text-gray-300">
              {{ messages + "privateNumberPriceAuthentication" | translate }}
            </span>
          </div>

          <div class="tw-mb-2">
            <span
              class="tw-text-gray-700 dark:tw-text-gray-300"
              [innerHTML]="
                messages + 'PrivateNumberPriceDeleteOrCancel' | translate
              "
            >
            </span>
          </div>

          <div class="tw-mb-2">
            <span class="text-danger">*</span>
            <span class="tw-text-gray-700 dark:tw-text-gray-300">
              {{
                messages + "notPossibleToChangeTheRequestedRegistrationNumber"
                  | translate
              }}
            </span>
          </div>

          <div class="tw-mb-2">
            <span class="text-danger">*</span>
            <span class="tw-text-gray-700 dark:tw-text-gray-300">
              {{
                messages + "PrivateNumberPriceWithoutAuthentication" | translate
              }}
            </span>
          </div>

          <h6 class="tw-mt-5">
            {{ "messages.privateNumberPurchaseRulesTitr" | translate }} :
          </h6>

          <ol class="tw-pr-5">
            <li class="tw-mb-2">
              <span class="tw-text-gray-700 dark:tw-text-gray-300">
                {{
                  "pages.privateNumbersPriceForUser.rules.buyNumberRule1"
                    | translate
                }}
              </span>
            </li>
            <li class="tw-mb-2">
              <span class="tw-text-gray-700 dark:tw-text-gray-300">
                {{
                  "pages.privateNumbersPriceForUser.rules.buyNumberRule2"
                    | translate
                }}
              </span>
            </li>
            <li class="tw-mb-2">
              <span class="tw-text-gray-700 dark:tw-text-gray-300">
                {{
                  "pages.privateNumbersPriceForUser.rules.buyNumberRule3"
                    | translate
                }}
              </span>
            </li>
            <li class="tw-mb-2">
              <span class="tw-text-gray-700 dark:tw-text-gray-300">
                {{
                  "pages.privateNumbersPriceForUser.rules.buyNumberRule4"
                    | translate
                }}
              </span>
            </li>
            <li class="tw-mb-2">
              <span class="tw-text-gray-700 dark:tw-text-gray-300">
                {{
                  "pages.privateNumbersPriceForUser.rules.buyNumberRule5"
                    | translate
                }}
              </span>
            </li>
            <li class="tw-mb-2">
              <span class="tw-text-gray-700 dark:tw-text-gray-300">
                {{
                  "pages.privateNumbersPriceForUser.rules.buyNumberRule6"
                    | translate
                }}
              </span>
            </li>
            <li class="tw-mb-2">
              <span class="tw-text-gray-700 dark:tw-text-gray-300">
                {{
                  "pages.privateNumbersPriceForUser.rules.buyNumberRule7"
                    | translate
                }}
              </span>
            </li>
            <li class="tw-mb-2">
              <span class="tw-text-gray-700 dark:tw-text-gray-300">
                {{
                  "pages.privateNumbersPriceForUser.rules.buyNumberRule8"
                    | translate
                }}
              </span>
            </li>
            <li class="tw-mb-2">
              <span class="tw-text-gray-700 dark:tw-text-gray-300">
                {{
                  "pages.privateNumbersPriceForUser.rules.buyNumberRule9"
                    | translate
                }}
              </span>
            </li>
            <li class="tw-mb-2">
              <span class="tw-text-gray-700 dark:tw-text-gray-300">
                {{
                  "pages.privateNumbersPriceForUser.rules.buyNumberRule10"
                    | translate
                }}
              </span>
            </li>
            <li class="tw-mb-2">
              <span class="tw-text-gray-700 dark:tw-text-gray-300">
                {{
                  "pages.privateNumbersPriceForUser.rules.buyNumberRule11"
                    | translate
                }}
              </span>
            </li>
            <li class="tw-mb-2">
              <span class="tw-text-gray-700 dark:tw-text-gray-300">
                {{
                  "pages.privateNumbersPriceForUser.rules.buyNumberRule12"
                    | translate
                }}
              </span>
            </li>
            <li class="tw-mb-2">
              <span class="tw-text-gray-700 dark:tw-text-gray-300">
                {{
                  "pages.privateNumbersPriceForUser.rules.buyNumberRule13"
                    | translate
                }}
              </span>
            </li>
            <li class="tw-mb-2">
              <span class="tw-text-gray-700 dark:tw-text-gray-300">
                {{
                  "pages.privateNumbersPriceForUser.rules.buyNumberRule14"
                    | translate
                }}
              </span>
            </li>
            <li class="tw-mb-2">
              <span class="tw-text-gray-700 dark:tw-text-gray-300">
                {{
                  "pages.privateNumbersPriceForUser.rules.buyNumberRule15"
                    | translate
                }}
              </span>
            </li>
            <li class="tw-mb-2">
              <span class="tw-text-gray-700 dark:tw-text-gray-300">
                {{
                  "pages.privateNumbersPriceForUser.rules.buyNumberRule16"
                    | translate
                }}
              </span>
              <ul style="list-style: outside" class="tw-pr-3">
                <li class="tw-text-gray-700 dark:tw-text-gray-300 tw-mr-3">
                  {{
                    "pages.privateNumbersPriceForUser.rules.buyNumberRule16_1"
                      | translate
                  }}
                </li>
                <li class="tw-text-gray-700 dark:tw-text-gray-300 tw-mr-3">
                  {{
                    "pages.privateNumbersPriceForUser.rules.buyNumberRule16_2"
                      | translate
                  }}
                </li>
                <li class="tw-text-gray-700 dark:tw-text-gray-300 tw-mr-3">
                  {{
                    "pages.privateNumbersPriceForUser.rules.buyNumberRule16_3"
                      | translate
                  }}
                </li>
              </ul>
            </li>
          </ol>
        </app-accordion-section>

        <div class="form-check tw-flex tw-mt-5">
          <input
            [(ngModel)]="isConfirm"
            class="form-check-input tw-ml-3 tw-mr-0 tw-pr-0 tw-w-[20px] tw-mt-1"
            type="checkbox"
            id="privateNumberPriceBuyRules"
          />
          <label
            class="form-check-label tw-font-semibold tw-w-full text-navyBlue tw-mt-1"
            for="privateNumberPriceBuyRules"
          >
            {{ "messages.ruleConfirmation" | translate }}
          </label>
        </div>
      </section>
      <!--#endregion -->
    </div>

    <!--#region form btns  -->
    <section class="tw-flex-center flex-column tw-mt-3">
      <button
        (click)="onSubmit()"
        class="btn bg-gradient-blue tw-w-[175px] tw-my-2 text-white btn-hover-rise"
        [disabled]="!isConfirm"
      >
        <span *ngIf="!loading">{{ "common.payment" | translate }}</span>

        <ng-container *ngIf="loading">
          <span
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          ></span>
          <span class="sr-only">Loading...</span>
        </ng-container>
      </button>
    </section>
    <!--#endregion -->
  </ng-container>

  <ng-container *ngIf="isSuccessPurchase">
    <div class="row">
      <div class="tw-w-full">
        <div class="tw-flex flex-column tw-items-center">
          <i
            class="mdi mdi-48px text-success mdi-check-decagram tw-mt-[20px]"
          ></i>
          <p class="tw-font-semibold text-success tw-text-[18px] tw-mt-2">
            {{ "messages.successfulPurchase" | translate }}
          </p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="tw-w-full">
        <p class="tw-text-gray-700 dark:tw-text-gray-300 tw-pr-1 tw-mb-2 tw-text-[13px]">
          {{ messages + "privateNumberPriceDetailsBought" | translate }}
        </p>
      </div>

      <!-- title -->
      <div class="sm:tw-w-1/2">
        <list-group-item
          paddingClass="tw-py-2"
          marginClass="tw-my-1"
          label="common.title"
          [value]="privateNumberPrice?.title"
        >
        </list-group-item>
      </div>

      <!-- smsCp -->
      <div class="sm:tw-w-1/2">
        <list-group-item
          paddingClass="tw-py-2"
          marginClass="tw-my-1"
          [label]="'common.smsCp'"
          [value]="privateNumberPrice?.smsCp | enumToText : SmsCpEnumValues"
        >
        </list-group-item>
      </div>

      <!-- numberOfDigits -->
      <div class="sm:tw-w-1/2">
        <list-group-item
          paddingClass="tw-py-2"
          marginClass="tw-my-1"
          [label]="fields + 'numberOfDigits'"
          [value]="privateNumberPrice?.numberOfDigits | numberSeparator"
        >
        </list-group-item>
      </div>

      <!-- reservationPeriod -->
      <div class="sm:tw-w-1/2">
        <list-group-item
          paddingClass="tw-py-2"
          marginClass="tw-my-1"
          [label]="fields + 'reservationPeriodWithoutDay'"
          [isShowValue]="false"
        >
          <div
            class="tw-flex badge badge-light border tw-text-gray-800 tw-text-[13px] text-wrap"
            content
          >
            <span>{{
              privateNumberPrice?.reservationPeriod | numberSeparator
            }}</span>
            <span>{{ "common.day" | translate }}</span>
          </div>
        </list-group-item>
      </div>

      <!-- isRound -->
      <div class="sm:tw-w-1/2">
        <list-group-item
          paddingClass="tw-py-2"
          marginClass="tw-my-1"
          [label]="fields + 'isRound'"
          [isShowValue]="false"
        >
          <div content class="tw-py-[4px]">
            <i
              class="mdi mdi-check-bold text-success mdi-20px"
              *ngIf="privateNumberPrice?.isRound"
            ></i>
            <i
              class="mdi mdi-close-thick text-danger mdi-20px"
              *ngIf="!privateNumberPrice?.isRound"
            ></i>
          </div>
        </list-group-item>
      </div>

      <!-- price -->
      <div class="sm:tw-w-1/2" *ngIf="discountAmount">
        <list-group-item
          paddingClass="tw-py-2"
          marginClass="tw-my-1"
          label="common.price"
          [value]="privateNumberPrice?.price | numberSeparator"
        >
        </list-group-item>
      </div>

      <!-- discountAmount -->
      <div class="sm:tw-w-1/2" *ngIf="discountAmount">
        <list-group-item
          paddingClass="tw-py-2"
          marginClass="tw-my-1"
          label="common.discount"
          [value]="discountAmount | numberSeparator"
        >
        </list-group-item>
      </div>

      <!-- finalAmount -->
      <div class="sm:tw-w-1/2">
        <list-group-item
          paddingClass="tw-py-2"
          marginClass="tw-my-1"
          label="common.paymentAmount"
          [value]="finalAmount | numberSeparator"
        >
        </list-group-item>
      </div>

      <section class="tw-w-full">
        <div class="alert tw-mb-0 tw-mt-[20px]">
          <div class="tw-mb-2 tw-text-gray-800">
            <span
              class="tw-text-gray-700 dark:tw-text-gray-300"
              [innerHTML]="
                messages + 'PrivateNumberPriceDeleteOrCancelAfterBuy'
                  | translate
              "
            >
            </span>
          </div>

          <p class="tw-mb-2 tw-text-gray-800">
            <span class="text-danger">*</span>
            <span class="tw-text-gray-700 dark:tw-text-gray-300">
              {{
                messages + "privateNumberPriceAuthenticationAfterBuy"
                  | translate
              }}
            </span>
          </p>

          <div class="tw-flex-center tw-mt-5 tw-pt-2">
            <a (click)="onSuccess()" class="btn tw-mx-2" [themeColor]="'btn'">
              {{ "common.isAuthenticated" | translate }}
            </a>

            <a (click)="onClose()" class="btn btn-secondary tw-mx-2">
              {{ "common.nowNo" | translate }}
            </a>
          </div>
        </div>
      </section>
    </div>
  </ng-container>
</div>
